import React from 'react';

import { useReactNodeView } from '@lyearn/lygo-core';

import FlashCardContainer from './components/FlashCardContainer';

const FlashCardNodeView: React.FC = () => {
  const { node, view } = useReactNodeView();

  return (
    <FlashCardContainer
      card={node?.attrs.card}
      readOnly={!view?.editable}
      type={node?.attrs.type}
    />
  );
};

export default FlashCardNodeView;
